import SchedulingOthersView from './SchedulingOthersView';

export default SchedulingOthersView;